<template>
  <v-form @submit.prevent="searchClick">
    <div class="font-weight-bold" style="font-size: 20px;">
      Search our network of service pros
    </div>

    <div class="d-flex align-center">
      <v-text-field
        v-model="search"
        outlined dense hide-details="auto"
        class="mt-2"
        placeholder="What service do you need?"
      />

      <v-btn type="submit" class="mt-2 ml-2" color="primary">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'QRSearchBar',

  data: () => ({
    loading: false,
    search: '',
  }),

  methods: {
    searchClick() {
      this.$router.replace({ name: 'wizard/service', query: { s: this.search } })
    },
  },
}
</script>